
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.697 7.117c-.209-.5-.458-.894-.75-1.186l-4.87-4.87c-.29-.29-.686-.54-1.186-.749C14.392.104 13.934 0 13.518 0h-9.99c-.416 0-.77.146-1.061.437a1.441 1.441 0 00-.437 1.061v20.978c0 .417.145.77.437 1.062.291.29.645.437 1.061.437H20.51c.417 0 .77-.146 1.061-.437.292-.292.437-.645.437-1.062V8.491c0-.416-.103-.874-.311-1.374zM13.345 1.41c.302.104 1.187.219 1.312.343l5.533 5.599c.125.125.24 1.01.343 1.311h-7.188V1.41zM3.424 22.648v-21.3h8.595V8.49c0 .416.146.77.437 1.061.292.292.645.437 1.062.437h7.02v12.659H3.423z","fill":"#A4A8C0","fill-rule":"nonzero"}})])
          )
        }
      }
    